import Container from "components/Container";
import Footer from "views/Footer/Footer";
import Header from "views/Header/Header";

const CustomContainer = ({ children, container }) => {
  return (
    <>
      <Header></Header>
      {container && <Container>{children}</Container>}
      {!container && <>{children}</>}
      <Footer />
    </>
  );
};
export default CustomContainer;
